import { Button } from '@/components/ui/Button';
import { isSafeAssetUrl } from '@/helpers/assetUrl';

import { StickyActionBar } from './StickyActionBar';

export interface ReturnHomeButtonProps {
  /** Merchant `returnUrl`. Rendered only after the scheme allowlist. */
  href: string | null;
  /** Already localized. */
  label: string;
}

/**
 * Leave-cashier CTA back to the merchant. `returnUrl` is merchant-controlled, so an unsafe
 * string is omitted rather than followed (ADR-039). The token is never added to the destination.
 * Waiting screens pass the raw URL; terminal screens pass the built result URL.
 */
export function ReturnHomeButton({ href, label }: ReturnHomeButtonProps) {
  if (!isSafeAssetUrl(href)) return null;

  return (
    <StickyActionBar>
      <Button
        size="lg"
        fullWidth
        onClick={() => {
          window.location.assign(href);
        }}
      >
        {label}
      </Button>
    </StickyActionBar>
  );
}
